import {Checkbox, FormLayout, InlineStack, Select, TextField} from "@shopify/polaris";
import {toDate} from "../Dates";
import {useCallback, useState} from "react";
import {ShipDateSelector} from "./ShipDateSelector";

export default ({form, setForm, loading, config, errors, hasPickReadyTag = false, opfPrefill, paymentMethods = {}, customerName = ''}) => {
    const paymentMethodsTransformed = Object.keys(paymentMethods)
        .map(key => {
            return {
                label: paymentMethods[key],
                value: key,
            };
        });

    const changeOrderProcessingFormValue = useCallback((value, id) => {
        let values = {
            ...form,
            [id]: value,
        };

        if (id === 'terms_code') {
            const paymentMethod = paymentMethodsTransformed.filter(row => row.value === value)[0]?.label;
            values = {
                ...values,
                payment_method: paymentMethod,
            }
        }

        setForm(values);

    }, [form]);

    const getNumericOptions = (num) => {
        let options = [];
        let x = 0;

        while(x < num) {
            options.push({
                label: x,
                value: x.toString(),
            });
            x++;
        }

        return options;
    }

    const getValue = useCallback((key) => {
        if (form && form[key] && form[key].length) {
            return form[key];
        }

        if (key === 'contact') {
            setForm((form) => ({
                ...form,
                [key]: customerName
            }));
            return customerName;
        }

        if (opfPrefill && opfPrefill[key] && opfPrefill[key].length) {
            setForm((form) => ({
                ...form,
                [key]: opfPrefill[key]
            }));
            return opfPrefill[key];
        }

        return '';
    }, [form, opfPrefill]);

    return (
        <FormLayout>
            <FormLayout.Group condensed>
                <TextField autoComplete={'off'} label="Contact" disabled={loading || hasPickReadyTag} value={getValue('contact')} id="contact" onChange={changeOrderProcessingFormValue} />
                <TextField autoComplete={'off'} label="Bill Freight to" disabled={loading || hasPickReadyTag} value={form?.bill_freight_to ?? ''} id="bill_freight_to" onChange={changeOrderProcessingFormValue} />
            </FormLayout.Group>

            <FormLayout.Group condensed>
                <TextField autoComplete={'off'} label="Airline" disabled={loading || hasPickReadyTag} value={getValue('airline')} id="airline" onChange={changeOrderProcessingFormValue} />
                <TextField autoComplete={'off'} label="Destination Airport" disabled={loading || hasPickReadyTag} value={getValue('destination_airport')} id="destination_airport" onChange={changeOrderProcessingFormValue} />
                <Select
                    label="Cutoff (LAX)"
                    disabled={loading || hasPickReadyTag}
                    value={form?.cutoff ?? ''}
                    id="cutoff"
                    onChange={changeOrderProcessingFormValue}
                    error={errors.cutoff}
                    options={[
                        '',
                        '7am',
                        '8am',
                        '9am',
                        '10am',
                        '11am',
                        '12pm',
                        '1pm',
                        '2pm',
                        '3pm',
                        '4:02pm',
                        '5pm',
                        '6pm',
                        '7pm',
                        '8pm',
                        '9pm',
                        '10pm',
                        '11pm',
                    ]}
                />
                <TextField autoComplete={'off'} label="Requested Delivery Date" disabled={loading} value={getValue('requested_delivery_date')} id="requested_delivery_date" onChange={changeOrderProcessingFormValue} />
            </FormLayout.Group>

            <FormLayout.Group condensed title={"Estimated Boxes"}>
                <TextField
                    autoComplete={'off'}
                    type={'number'}
                    step={1}
                    min={0}
                    disabled={loading || hasPickReadyTag}
                    label="Rock"
                    value={form?.estimated_rock_boxes?.toString() ?? ''} id="estimated_rock_boxes"
                    onChange={(value) => changeOrderProcessingFormValue(parseInt(value), 'estimated_rock_boxes')}
                />
                <TextField
                    autoComplete={'off'}
                    type={'number'}
                    step={1}
                    min={0}
                    disabled={loading || hasPickReadyTag}
                    label="Dry Goods"
                    value={form?.estimated_dry_goods_boxes?.toString() ?? ''} id="estimated_dry_goods_boxes"
                    onChange={(value) => changeOrderProcessingFormValue(parseInt(value), 'estimated_dry_goods_boxes')}
                />
                <TextField
                    autoComplete={'off'}
                    type={'number'}
                    step={1}
                    min={0}
                    disabled={loading || hasPickReadyTag}
                    label="Saltwater"
                    value={form?.estimated_saltwater_boxes?.toString() ?? ''} id="estimated_saltwater_boxes"
                    onChange={(value) => changeOrderProcessingFormValue(parseInt(value), 'estimated_saltwater_boxes')}
                />
                <TextField
                    autoComplete={'off'}
                    type={'number'}
                    step={1}
                    min={0}
                    disabled={loading || hasPickReadyTag}
                    label="Freshwater"
                    value={form?.estimated_freshwater_boxes?.toString() ?? ''} id="estimated_freshwater_boxes"
                    onChange={(value) => changeOrderProcessingFormValue(parseInt(value), 'estimated_freshwater_boxes')}
                />
                <TextField
                    autoComplete={'off'}
                    type={'number'}
                    step={1}
                    min={0}
                    disabled={loading || hasPickReadyTag}
                    label="Livestock"
                    value={form?.estimated_livestock_boxes?.toString() ?? ''} id="estimated_livestock_boxes"
                    onChange={(value) => changeOrderProcessingFormValue(parseInt(value), 'estimated_livestock_boxes')}
                />
            </FormLayout.Group>

            <FormLayout.Group condensed>
                <Select
                    label={'Wave'}
                    options={getNumericOptions(8)}
                    value={form?.wave?.toString() ?? ''}
                    id="wave"
                    disabled={loading || hasPickReadyTag}
                    onChange={(value) => changeOrderProcessingFormValue(parseInt(value), 'wave')}
                />
                <TextField
                    autoComplete={'off'}
                    type={'number'}
                    step={1}
                    min={0}
                    disabled={loading || hasPickReadyTag}
                    label="Heat Packs per box"
                    value={form?.heat_packs_per_box?.toString() ?? ''} id="heat_packs_per_box"
                    onChange={(value) => changeOrderProcessingFormValue(parseInt(value), 'heat_packs_per_box')}
                />
                <TextField
                    autoComplete={'off'}
                    type={'number'}
                    step={1}
                    min={0}
                    disabled={loading || hasPickReadyTag}
                    label="Gel Packs per box"
                    value={form?.gel_packs_per_box?.toString() ?? ''} id="gel_packs_per_box"
                    onChange={(value) => changeOrderProcessingFormValue(parseInt(value), 'gel_packs_per_box')}
                />
                <TextField autoComplete={'off'} label="Estimated Arrival" disabled={loading || hasPickReadyTag} value={form?.estimated_arrival ?? ''} id="estimated_arrival" onChange={changeOrderProcessingFormValue} />
                <TextField autoComplete={'off'} label="Estimated Weight" disabled={loading || hasPickReadyTag} value={form?.estimated_weight ?? ''} id="estimated_weight" onChange={changeOrderProcessingFormValue} />
            </FormLayout.Group>

            <FormLayout.Group condensed>
                <Select
                    label={"Payment Method"}
                    id="terms_code"
                    onChange={changeOrderProcessingFormValue}
                    value={getValue('terms_code') ?? '00'}
                    disabled={loading || hasPickReadyTag}
                    options={paymentMethodsTransformed}
                />

                <Checkbox
                    label={"Credits Due"}
                    id="credits_due"
                    onChange={changeOrderProcessingFormValue}
                    checked={form?.credits_due ?? ''}
                    disabled={loading || hasPickReadyTag}
                />

                <Select
                    label={"Billing Method"}
                    id="billing_method"
                    onChange={changeOrderProcessingFormValue}
                    value={form?.billing_method ?? 'dealer'}
                    options={[
                        {label: "Dealer", value: 'dealer'},
                        {label: "Distributor", value: 'distributor'},
                    ]}
                    disabled={loading || hasPickReadyTag}
                />
            </FormLayout.Group>

            {  ['33', '37', '39', '40', '50', '60', '70', '80', '85'].includes(getValue('terms_code')) && (<FormLayout.Group condensed title={"Credit Card Payment"}>
                <TextField
                    autoComplete={'off'}
                    label="Last 4"
                    value={form?.payment_cc_last_4 ?? ''}
                    id="payment_cc_last_4"
                    onChange={changeOrderProcessingFormValue}
                    max={4}
                    disabled={loading || hasPickReadyTag}
                />
                <TextField
                    autoComplete={'off'}
                    label="Exp"
                    value={form?.payment_cc_exp_date ?? ''}
                    id="payment_cc_exp_date"
                    onChange={changeOrderProcessingFormValue}
                    disabled={loading || hasPickReadyTag}
                />
                <TextField
                    autoComplete={'off'}
                    label="Pre-Auth Amount"
                    value={form?.payment_cc_pre_auth_amount ?? ''}
                    id="payment_cc_pre_auth_amount"
                    onChange={changeOrderProcessingFormValue}
                    type={'number'}
                    step={0.1}
                    min={0}
                    disabled={loading || hasPickReadyTag}
                    prefix={'$'}
                />
            </FormLayout.Group>)}

            { getValue('terms_code') == '95' && (<FormLayout.Group condensed title={"Wired Payment"}>
                <Checkbox
                    label={"Received"}
                    id="payment_wire_received"
                    onChange={changeOrderProcessingFormValue}
                    checked={form?.payment_wire_received ?? ''}
                    disabled={loading || hasPickReadyTag}
                />
            </FormLayout.Group>)}

            <TextField
                label={'Packing Instructions'}
                autoComplete={'off'}
                type={'text'}
                multiline={4}
                id={'packing_instructions'}
                value={form?.packing_instructions ?? ''}
                onChange={changeOrderProcessingFormValue}
                disabled={loading || hasPickReadyTag}
            />

        </FormLayout>
    )
}
